module.exports = __webpack_public_path__ + "static/media/w3.efbf741f.png";